import React from "react";
import FormCheckboxGroup from "../../FormCheckboxGroup";
import Button from "../../Button";
import FormTextArea from "../../FormTextarea";
import { useFormikContext } from "formik";
import Loader from "../../Loader";

interface CustomerReportFormProps {
  loading: boolean;
  formStep: number;
  setFormStep: React.Dispatch<React.SetStateAction<number>>;
  handleDoneClick: () => void;
}

const CustomerReportForm: React.FC<CustomerReportFormProps> = ({
  loading,
  formStep,
  setFormStep,
  handleDoneClick,
}) => {
  const { values, validateForm, setTouched, submitForm }: any =
    useFormikContext();

  const PROPERTY_REPORT_REASON = [
    { label: "Customer", value: "customer" },
    { label: "Agent", value: "agent" },
    {
      label: "Home is no longer available",
      value: "Home is no longer available",
    },
    {
      label: "Incorrect information/photos",
      value: "Incorrect information/photos",
    },
    {
      label: "Fraudulent listing or spam",
      value: "Fraudulent listing or spam",
    },
  ];

  const handleNextStep = async () => {
    const errors = await validateForm();
    if (Object.keys(errors).length === 0) {
      if (formStep === 2) {
        await submitForm();
        return;
      } else {
        setFormStep(formStep + 1);
      }
    } else {
      setTouched(errors);
    }
  };

  const handlePreviousStep = () => {
    setFormStep(formStep - 1);
    if (formStep === 1) {
      return;
    }
    setFormStep(formStep - 1);
  };

  return (
    <div>
      {formStep === 1 ? (
        <div className="mb-4">
          <h2 className="mb-6 font-semibold text-2xl">What's the issue?</h2>
          <FormCheckboxGroup
            type="radio"
            name="reason"
            options={PROPERTY_REPORT_REASON}
            className="flex flex-col justify-center items-start"
          />
        </div>
      ) : formStep === 2 ? (
        <div>
          <h2 className="mb-6 font-semibold text-2xl">
            Reason type: {values?.reason}
          </h2>
          <FormTextArea
            name="description"
            id="report-description"
            placeholder="Please describe your concerns"
            label="Description"
            className="!mb-8"
            required
          />
        </div>
      ) : formStep === 3 ? (
        <div>
          <h2 className="mb-2 font-semibold text-2xl">Thank you!</h2>
          <p className="mb-2 text-xl">
            Thank you for bringing this to our attention. We appreciate your
            help in keeping our listings accurate. Our team will review the
            issue as soon as possible. If you have any further concerns, feel
            free to reach out.
          </p>
        </div>
      ) : null}
      {formStep !== 3 ? (
        <div className="flex justify-start items-center gap-x-4">
          <Button
            type="button"
            className="rounded-md"
            onClick={handleNextStep}
            disabled={loading}
          >
            {loading ? (
              <Loader size="small" />
            ) : formStep === 2 ? (
              "Submit"
            ) : (
              "Continue"
            )}
          </Button>
          {formStep === 2 ? (
            <Button
              className="rounded-md"
              variant="secondary"
              onClick={handlePreviousStep}
              disabled={loading}
            >
              Back
            </Button>
          ) : null}
        </div>
      ) : (
        <Button
          type="button"
          className="rounded-md"
          onClick={handleDoneClick}
          disabled={loading}
        >
          Done
        </Button>
      )}
    </div>
  );
};

export default CustomerReportForm;
